<template>
  <b-row>
    <b-col lg="2">
      <b-card class="picture-div">
        <LoadingCard v-if="loadingData"></LoadingCard>
        <div v-else style="min-height:240px">
          <div class="container">
            <img
              :src="data.driver_img"
              class="img-circle"
              alt="fibernode.com"
              style="display:block; margin:auto"
            />
            <span
              style="display:block; text-align:center; margin-top:10px; font-size:17px"
            >
              {{ data.driver }}
            </span>
          </div>
        </div>
      </b-card>
    </b-col>

    <b-col lg="4">
      <b-card>
        <LoadingCard v-if="loadingData"></LoadingCard>
        <div v-else style="min-height: 240px;">
          <div class="container">
            <h4 style="margin-bottom:25px">Details</h4>
            <span style="display:block; font-size:1.1em"
              ><i
                class="fa fa-calendar"
                style="margin-right:10px"
                aria-hidden="true"
              ></i
              >Delivery Date
              <b> {{ $formatUSDate(data.delivery_date) }} </b></span
            >
            <span style="display:block; font-size:1.1em"
              ><i
                class="fa fa-server"
                style="margin-right:10px"
                aria-hidden="true"
              ></i
              >Total<b> {{ data.units }} units </b></span
            >
            <span style="display:block; font-size:1.1em; margin-top:10px"
              ><i
                class="fa fa-file"
                style="margin-right:10px"
                aria-hidden="true"
              ></i
              >Invoice<b> {{ data.fnsInvoiceNum }} </b></span
            >
            <span style="display:block; font-size:1.1em"
              ><i
                class="fa fa-calendar"
                style="margin-right:10px"
                aria-hidden="true"
              ></i
              >Invoice Date<b> {{ data.fnsInvoicedate }} </b></span
            >
            <span style="display:block; font-size:1.1em"
              ><i
                class="fa fa-comment"
                style="margin-right:10px"
                aria-hidden="true"
              ></i
              >Comment:<b> {{ data.comment }} </b></span
            >
            <b-button
              @click="downloadShippingRecord()"
              variant="primary"
              style="margin-top:5px"
              right
              >Download Shipping Record</b-button
            >
          </div>
        </div>
      </b-card>
    </b-col>

    <b-col lg="3">
      <b-card class="picture-div">
        <LoadingCard v-if="loadingData"></LoadingCard>
        <div v-else style="min-height: 240px;">
          <div class="container">
            <h4 style="margin-bottom:25px">Signature</h4>
            <img
              v-if="
                data.signature !==
                  'https://fibernode.com/storage/proof-of-delivery-signature/'
              "
              :src="data.signature"
              class="img-circle"
              alt="fibernode.com"
              style="display:block; margin:auto;"
            />
            <span
              v-else
              style="display:block; margin:auto; text-align:center; font-size:1.3em;"
              >No Signature Image</span
            >
          </div>
        </div>
      </b-card>
    </b-col>

    <b-col lg="3">
      <b-card class="picture-div">
        <LoadingCard v-if="loadingData"></LoadingCard>
        <div v-else style="min-height: 240px;">
          <div class="container">
            <h4 style="margin-bottom:25px">Location</h4>
            <gmap-map
              v-if="data.lat && data.lng && data.lat != '0.0000000'"
              :center="center"
              :options="mapOptions"
              style="width:100%;  height: 160px;"
            >
              <gmap-marker
                :key="key"
                v-for="(item, key) in center"
                :position="getPosition(item)"
              ></gmap-marker>
            </gmap-map>
            <span
              v-else
              style="display:block; margin:auto; text-align:center; font-size:1.3em;"
              >No Location Data</span
            >
          </div>
        </div>
      </b-card>
    </b-col>

    <b-col lg="6" offset-lg="3" v-if="data.images">
      <b-card class="picture-div">
        <b-carousel
          id="carousel1"
          style="text-shadow: 1px 1px 2px #333;"
          controls
          indicators
          background="#ababab"
          :interval="4000"
        >
          <b-carousel-slide
            style=""
            class="my-slider"
            v-for="img in data.images"
            v-bind:key="img"
            :img-src="'https://fibernode.com/storage/proof-of-delivery/' + img"
          >
            <b-btn variant="primary" @click="openImage(img)">Open</b-btn>
          </b-carousel-slide>
        </b-carousel>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import LoadingCard from "../../../components/shared/LoadingCard.vue";

export default {
  name: "ProofOfDeliveryDetails",
  components: { LoadingCard },
  data() {
    return {
      envVar: process.env.VUE_APP_TRACKER_URL,
      data: [],
      loadingData: true,
      mapOptions: {
        zoom: 7,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: true,
        scrollwheel: true,
        draggable: true
      },
      center: { lat: null, lng: null }
    };
  },
  methods: {
    getInfo() {
      let params = {};
      params = {
        ranum: this.$route.query.ranum,
        date: this.$route.query.shipDate
      };
      this.$http.get("api/tables/pod_details.php", { params }).then(
        res => {
          this.data = res.data;
          this.center.lat = parseFloat(res.data.lat);
          this.center.lng = parseFloat(res.data.lng);
          this.loadingData = false;
        },
        err => {
          console.log(err);
        }
      );
    },

    downloadShippingRecord() {
      window.location.href =
        this.envVar +
        "tracker_private/spreadsheets/shippingRecordByDatePublic.php?date=" +
        this.$route.query.shipDate +
        "&ranum=" +
        this.$route.query.ranum;
    },

    openImage(img) {
      window.location.href =
        "https://fibernode.com/storage/proof-of-delivery/" + img;
    },

    getPosition: function() {
      return {
        lat: parseFloat(this.center.lat),
        lng: parseFloat(this.center.lng)
      };
    }
  },
  mounted() {
    this.loadingData = true;
    this.getInfo();
  }
};
</script>

<style>
.my-slider {
  background: #3a4149 !important;
}
.my-slider img {
  margin: auto;
  width: auto !important;
  max-height: 500px;
}
</style>
